import React from "react";
import { Link } from "react-router-dom";

const Unauthorized: React.FC = () => (
  <div className="flex flex-col items-center justify-center h-full py-20 text-center space-y-4">
    <h1 className="text-2xl font-semibold">Unauthorized</h1>
    <p>You do not have permission to view this page.</p>
    <Link to="/" className="text-info-600 hover:underline">
      Go back to dashboard
    </Link>
  </div>
);

export default Unauthorized;
